<div class="modal-component">
    <div class="modal-header">
        <div class="header_details">
            <div class="title">Export channel</div>
        </div>
    </div>

    <div class="modal-body">
        @if (errorMessage) {
            <div class="error">{{ errorMessage }}</div>
        }

        <form novalidate #exportChannelForm="ngForm" id="exportChannel_form" [formGroup]="form">
            <mat-form-field class="form-group app-mat-form-field" appearance="outline">
                <mat-label>Offset</mat-label>

                <input
                    class="validate"
                    type="number"
                    placeholder="Write a offset"
                    formControlName="offset"
                    data-testid="offset-input"
                    required
                    matInput
                />

                @if (
                    (form.get('offset').dirty || form.get('offset').touched) &&
                    form.invalid &&
                    form.get('offset').hasError('required')
                ) {
                    <mat-error class="error-msg"> Offset is required </mat-error>
                }
                @if (
                    (form.get('offset').dirty || form.get('offset').touched) &&
                    form.invalid &&
                    form.get('offset').hasError('min')
                ) {
                    <mat-error class="error-msg"> Minimum allowable value 0 </mat-error>
                }
            </mat-form-field>

            <mat-form-field class="form-group app-mat-form-field" appearance="outline">
                <mat-label>Count</mat-label>

                <input
                    class="validate"
                    type="number"
                    placeholder="Write a offset"
                    formControlName="count"
                    data-testid="count-input"
                    required
                    matInput
                />

                @if (
                    (form.get('count').dirty || form.get('count').touched) &&
                    form.invalid &&
                    form.get('count').hasError('required')
                ) {
                    <mat-error class="error-msg"> Count is required </mat-error>
                }
                @if (
                    (form.get('count').dirty || form.get('count').touched) &&
                    form.invalid &&
                    form.get('count').hasError('min')
                ) {
                    <mat-error class="error-msg"> Minimum allowable value 1 </mat-error>
                }
            </mat-form-field>

            <div class="form-group">
                <label>Type <span class="red">*</span></label>

                <div class="mat-checkbox-wrap">
                    <mat-radio-group
                        aria-labelledby="example-radio-group-label"
                        class="example-radio-group"
                        formControlName="type"
                    >
                        @for (exportType of exportTypes; track exportType) {
                            <mat-radio-button class="example-radio-button" [value]="exportType">
                                {{ exportType | uppercase }}
                            </mat-radio-button>
                        }
                    </mat-radio-group>
                </div>
            </div>

            <div class="form_btns">
                <button
                    class="cancel-button btn"
                    data-testid="close-export-channel-button"
                    mat-flat-button
                    (click)="close()"
                >
                    Cancel
                </button>
                <button
                    class="primary_btn btn"
                    type="submit"
                    matomoClickCategory="export-channel-modal"
                    matomoClickAction="click"
                    matomoClickName="export-channel"
                    [disabled]="!exportChannelForm.form.valid || isSubmitting"
                    (click)="checkForm = true; exportChannel()"
                    mat-raised-button
                    [disabled]="isSubmitting"
                    data-testid="export-submit-input"
                >
                    @if (isSubmitting) {
                        <mat-spinner color="primary" [strokeWidth]="2" [diameter]="20"></mat-spinner>
                    } @else {
                        <span>Export</span>
                    }
                </button>
            </div>
        </form>
    </div>
</div>
